import React from "react";
import { Route } from "react-router-dom";
import CommonLayout from "../layout/CommonLayout"

export default function AppliedRoute({ component: C, appProps, headerCaptionApplicable, ...rest }) {
  return (
    <Route {...rest} render={props => <CommonLayout {...props} {...appProps} headerCaptionApplicable={headerCaptionApplicable}><C {...props} {...appProps} /></CommonLayout>} />
  );
}
